var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7875 1.34766H3.19302C1.77166 1.34766 0.615234 2.50385 0.615234 3.92544V12.2449C0.615234 13.6633 1.76662 14.8177 3.18386 14.8227V18.598L8.60939 14.8227H16.7875C18.2088 14.8227 19.3652 13.6663 19.3652 12.2449V3.92544C19.3652 2.50385 18.2088 1.34766 16.7875 1.34766ZM18.2666 12.2449C18.2666 13.0604 17.6031 13.7241 16.7875 13.7241H8.26469L4.28249 16.4952V13.7241H3.19302C2.3774 13.7241 1.71387 13.0604 1.71387 12.2449V3.92544C1.71387 3.1097 2.3774 2.44629 3.19302 2.44629H16.7875C17.6031 2.44629 18.2666 3.1097 18.2666 3.92544V12.2449Z",
    fill: "#868686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63354 5.22949H14.3469V6.32812H5.63354V5.22949Z",
    fill: "#868686"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63354 7.57324H14.3469V8.67187H5.63354V7.57324Z",
    fill: "#868686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63354 9.91699H14.3469V11.0156H5.63354V9.91699Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.b7a716f3.svg";
export { ForwardRef as ReactComponent };